/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, displayStringFromFHIRCodeableConcept, simpleDisplayStringFromFHIRCodeableConcept } from "../datatypeComponents/CodeableConceptEntry";
import QuantityEntry, { displayStringFromFHIRQuantity } from "../datatypeComponents/QuantityEntry";
import RangeEntry, { displayStringFromFHIRRange } from "../datatypeComponents/RangeEntry";
import ReferenceEntry, { DisplayFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";
import StringEntry from "../datatypeComponents/StringEntry";
import DatatypeSelector from "../datatypeComponents/DatatypeSelector";
import PeriodEntry, { DateTimeEntry, displayStringFromFHIRPeriod, getDateTimeDisplay } from "../datatypeComponents/PeriodEntry";
import RelativeTimeEntry, { displayStringFromFHIRRelativeTime } from "../datatypeComponents/RelativeTimeEntry";
import ExpressionEntry, { DisplayFromFHIRExpression } from "../datatypeComponents/ExpressionEntry";
import UriEntry, { DisplayFromFHIRUri } from "../datatypeComponents/UriEntry";
import BooleanEntry, { displayStringFromFHIRBoolean } from "../datatypeComponents/BooleanEntry";
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../slices/editMode/editModeSlice";
import { resourceUpdated, selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import { selectAllResourceChanges } from "../slices/resourceChangeReport/resourceChangeReportSlice";
import { changeTopNavigationElements } from "../slices/navigationPanel/navigationPanelSlice";
import { changeTabMenu } from "../slices/tabPane/tabPaneSlice";
import updateElement, { updateNarrativeElement } from "../functions/updateElement";
import updateChangeReport from "../slices/resourceChangeReport/updateChangeReport";
import Spinner from "../components/Spinner";
import { Table } from "semantic-ui-react";
import CodeableReferenceEntry, { DisplayFromFHIRCodeableReference } from "../datatypeComponents/CodeableReferenceEntry";
import NarrativeEntry, { DisplayFromFHIRXhtml } from "../datatypeComponents/NarrativeEntry";
import { DisplayFromFHIRAnnotation } from "../datatypeComponents/AnnotationEntry";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import ArrayEntry from "../datatypeComponents/ArrayEntry";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import UnsignedIntEntry from "../datatypeComponents/UnsignedIntEntry";
import PositiveIntEntry from "../datatypeComponents/PositiveIntEntry";
import generateNarrativeForEvidenceVariableResource from "./generateNarrativeFunctions/generateNarrativeForEvidenceVariableResource";
import { selectOlderVersionFhirString, selectViewingOlderVersion } from "../slices/viewingOlderVersion/viewingOlderVersionSlice";
import convertEvidenceVariableHandlingToCodeableConcept from "./resourceDisplayCommonFunctions/convertEvidenceVariableHandlingToCodeableConcept";

const evidenceVariableDotDefinitionResourceTypes = ['Group'];
const evidenceVariableDefinitionConceptSystemChoices = [
    { 'uri': 'http://snomed.info/sct', 'display': 'SNOMED CT' },
    { 'uri': 'http://hl7.org/fhir/sid/icd-10', 'display': 'ICD-10' },
    { 'uri': 'http://loinc.org', 'display': 'LOINC' },
    { 'uri': 'http://www.nlm.nih.gov/research/umls/rxnorm', 'display': 'RxNorm' },
    { 'uri': 'https://www.whocc.no/atc_ddd_index/', 'display': 'ATC' },
    { 'uri': 'https://www.nlm.nih.gov/mesh', 'display': 'MeSH' }
];
const evidenceVariableDotHandlingValueSet = [
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "boolean", display: "boolean variable" }]
    },
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "continuous", display: "continuous variable" }]
    },
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "dichotomous", display: "dichotomous variable" }]
    },
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "ordinal", display: "ordinal variable" }]
    },
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "polychotomous", display: "polychotomous variable" }]
    },
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "time-to-event", display: "time-to-event" }]
    },
    {
        "coding": [{ system: "http://hl7.org/fhir/variable-handling", code: "not-specified", display: "not-specified" }]
    }
];
const evidenceVariableCategoryDotValueAllowedDatatypes = ['CodeableConcept', 'Quantity', 'Range', 'Reference'];

const EvidenceVariableCategoryEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {

    const [evidenceVariableCategoryState, setEvidenceVariableCategoryState] = useState({});
    const [evidenceVariableCategoryDotValueDatatypeState, setEvidenceVariableCategoryDotValueDatatypeState] = useState('none');
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingVariableCategory = {
            name: "", valueCodeableConcept: "", valueQuantity: "", valueRange: "", valueReference: ""
        }
        let startingEvidenceVariableCategoryDotValueDatatype = 'none';
        if (startingValue) {
            if (startingValue.extension) { startingVariableCategory.extension = startingValue.extension; }
            if (startingValue.name) { startingVariableCategory.name = startingValue.name; }
            if (startingValue.valueCodeableConcept) {
                startingVariableCategory.valueCodeableConcept = startingValue.valueCodeableConcept;
                startingEvidenceVariableCategoryDotValueDatatype = "CodeableConcept";
            }
            if (startingValue.valueQuantity) {
                startingVariableCategory.valueQuantity = startingValue.valueQuantity;
                startingEvidenceVariableCategoryDotValueDatatype = "Quantity";
            }
            if (startingValue.valueRange) {
                startingVariableCategory.valueRange = startingValue.valueRange;
                startingEvidenceVariableCategoryDotValueDatatype = "Range";
            }
            if (startingValue.valueReference) {
                startingVariableCategory.valueReference = startingValue.valueReference;
                startingEvidenceVariableCategoryDotValueDatatype = "Reference";
            }
        }
        setEvidenceVariableCategoryState(JSON.parse(JSON.stringify(startingVariableCategory))); //TODO -- is JSON.parseJSON.stringify unneeded here (and can be removed in many similar places?)
        setEvidenceVariableCategoryDotValueDatatypeState(startingEvidenceVariableCategoryDotValueDatatype);
    }, []);

    useEffect((() => {
        if (evidenceVariableCategoryDotValueDatatypeState === 'CodeableConcept') {
            setEvidenceVariableCategoryState(prevState => { return { ...prevState, 'valueQuantity': null, 'valueRange': null, 'valueReference': null } })
        }
        if (evidenceVariableCategoryDotValueDatatypeState === 'Quantity') {
            setEvidenceVariableCategoryState(prevState => { return { ...prevState, 'valueCodeableConcept': null, 'valueRange': null, 'valueReference': null } })
        }
        if (evidenceVariableCategoryDotValueDatatypeState === 'Range') {
            setEvidenceVariableCategoryState(prevState => { return { ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueReference': null } })
        }
        if (evidenceVariableCategoryDotValueDatatypeState === 'Reference') {
            setEvidenceVariableCategoryState(prevState => { return { ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null } })
        }
    }), [evidenceVariableCategoryDotValueDatatypeState]);

    useEffect((() => {
        if (Object.keys(evidenceVariableCategoryState).length > 0) {
            let newEvidenceVariableCategory = {};
            if (evidenceVariableCategoryState.extension) { newEvidenceVariableCategory.extension = evidenceVariableCategoryState.extension; }
            if (evidenceVariableCategoryState.name) { newEvidenceVariableCategory.name = evidenceVariableCategoryState.name; }
            if (evidenceVariableCategoryDotValueDatatypeState === 'CodeableConcept' && evidenceVariableCategoryState.valueCodeableConcept && Object.keys(evidenceVariableCategoryState.valueCodeableConcept).length > 0) {
                newEvidenceVariableCategory.valueCodeableConcept = evidenceVariableCategoryState.valueCodeableConcept;
            }
            if (evidenceVariableCategoryDotValueDatatypeState === 'Quantity' && evidenceVariableCategoryState.valueQuantity && Object.keys(evidenceVariableCategoryState.valueQuantity).length > 0) {
                newEvidenceVariableCategory.valueQuantity = evidenceVariableCategoryState.valueQuantity;
            }
            if (evidenceVariableCategoryDotValueDatatypeState === 'Range' && evidenceVariableCategoryState.valueRange && Object.keys(evidenceVariableCategoryState.valueRange).length > 0) {
                newEvidenceVariableCategory.valueRange = evidenceVariableCategoryState.valueRange;
            }
            if (evidenceVariableCategoryDotValueDatatypeState === 'Reference' && evidenceVariableCategoryState.valueReference && Object.keys(evidenceVariableCategoryState.valueReference).length > 0) {
                newEvidenceVariableCategory.valueReference = evidenceVariableCategoryState.valueReference;
            }
            if (Object.keys(newEvidenceVariableCategory).length === 0) {
                newEvidenceVariableCategory = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceVariableCategory }; });
        }
    }), [evidenceVariableCategoryState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {(startingValue.name && typeof startingValue.name === "string") && <p><b>Name: </b>{startingValue.name}</p>}
                {startingValue.valueCodeableConcept && <span><b>Value: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.valueCodeableConcept} /></span>}
                {startingValue.valueQuantity && <span> <b>Value: </b>{displayStringFromFHIRQuantity(startingValue.valueQuantity)}</span>}
                {startingValue.valueRange && <span><b>Value: </b>{displayStringFromFHIRRange(startingValue.valueRange)}</span>}
                {startingValue.valueReference && <span><b>Value: </b><DisplayFromFHIRReference reference={startingValue.valueReference} /></span >}
            </div >}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div >
    } else if (Object.keys(evidenceVariableCategoryState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <StringEntry elementName='name' fieldLabel='Category Name'
                    startingValue={evidenceVariableCategoryState.name} setResourceState={setEvidenceVariableCategoryState} />
                <DatatypeSelector elementXName='value[x]' allowedDatatypes={evidenceVariableCategoryDotValueAllowedDatatypes}
                    datatypeState={evidenceVariableCategoryDotValueDatatypeState} setDatatypeState={setEvidenceVariableCategoryDotValueDatatypeState} />
                {evidenceVariableCategoryDotValueDatatypeState === 'CodeableConcept' &&
                    <CodeableConceptEntry elementName='valueCodeableConcept'
                        fieldLabel='Category Definition as CodeableConcept'
                        startingValue={evidenceVariableCategoryState.valueCodeableConcept}
                        systemChoices={evidenceVariableDefinitionConceptSystemChoices} systemChoicesOpen={true}
                        setResourceState={setEvidenceVariableCategoryState} />}
                {evidenceVariableCategoryDotValueDatatypeState === 'Quantity' &&
                    <QuantityEntry elementName='valueQuantity' fieldLabel='Category Definition as Quantity'
                        startingValue={evidenceVariableCategoryState.valueQuantity}
                        setResourceState={setEvidenceVariableCategoryState} />}
                {evidenceVariableCategoryDotValueDatatypeState === 'Range' &&
                    <RangeEntry elementName='valueRange' fieldLabel='Category Definition as Range'
                        startingValue={evidenceVariableCategoryState.valueRange}
                        setResourceState={setEvidenceVariableCategoryState} />}
                {evidenceVariableCategoryDotValueDatatypeState === 'Reference' &&
                    <ReferenceEntry elementName='valueReference' fieldLabel='Category Definition as Reference'
                        startingValue={evidenceVariableCategoryState.valueReference} enableCreation={true}
                        referencedResourceTypes={["Group"]}
                        setResourceState={setEvidenceVariableCategoryState} />}
            </div>
        </>
    }
};

const EvidenceVariableDefinitionModifierDotValueAllowedDatatypes = ['CodeableConcept', 'boolean',
    'Quantity', 'Range', 'Period', 'RelativeTime', 'Reference', 'Expression', 'uri'];
const EvidenceVariableDefinitionModifierEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {

    const [evidenceVariableDefinitionModifierState, setEvidenceVariableDefinitionModifierState] = useState({});
    const [evidenceVariableDefinitionModifierDotValueDatatypeState, setEvidenceVariableDefinitionModifierDotValueDatatypeState] = useState('none');
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingDefinitionModifier = {
            code: "", valueCodeableConcept: "", valueBoolean: null, valueQuantity: "", valueRange: "",
            valuePeriod: "", valueRelativeTime: "", valueReference: "", valueExpression: "", valueUri: ""
        }
        let startingEvidenceVariableDefinitionModifierDotValueDatatype = 'none';
        if (startingValue) {
            if (startingValue.extension) { startingDefinitionModifier.extension = startingValue.extension; }
            if (startingValue.code) { startingDefinitionModifier.code = startingValue.code; }
            if (startingValue.valueCodeableConcept) {
                startingDefinitionModifier.valueCodeableConcept = startingValue.valueCodeableConcept;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "CodeableConcept";
            }
            if (typeof startingValue.valueBoolean === "boolean") {
                startingDefinitionModifier.valueBoolean = startingValue.valueBoolean;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "boolean";
            }
            if (startingValue.valueQuantity) {
                startingDefinitionModifier.valueQuantity = startingValue.valueQuantity;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "Quantity";
            }
            if (startingValue.valueRange) {
                startingDefinitionModifier.valueRange = startingValue.valueRange;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "Range";
            }
            if (startingValue.valuePeriod) {
                startingDefinitionModifier.valuePeriod = startingValue.valuePeriod;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "Period";
            }
            if (startingValue.valueRelativeTime) {
                startingDefinitionModifier.valueRelativeTime = startingValue.valueRelativeTime;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "RelativeTime";
            }
            if (startingValue.valueReference) {
                startingDefinitionModifier.valueReference = startingValue.valueReference;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "Reference";
            }
            if (startingValue.valueExpression) {
                startingDefinitionModifier.valueExpression = startingValue.valueExpression;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "Expression";
            }
            if (startingValue.valueUri) {
                startingDefinitionModifier.valueUri = startingValue.valueUri;
                startingEvidenceVariableDefinitionModifierDotValueDatatype = "uri";
            }
        }
        setEvidenceVariableDefinitionModifierState(JSON.parse(JSON.stringify(startingDefinitionModifier)));
        setEvidenceVariableDefinitionModifierDotValueDatatypeState(startingEvidenceVariableDefinitionModifierDotValueDatatype);
    }, []);

    useEffect((() => {
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'CodeableConcept') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueRange': null, 'valueReference': null,
                    "valueBoolean": null, "valuePeriod": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Quantity') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueCodeableConcept': null, 'valueRange': null, 'valueReference': null,
                    "valueBoolean": null, "valuePeriod": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Range') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueReference': null,
                    "valueBoolean": null, "valuePeriod": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Reference') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null,
                    "valueBoolean": null, "valuePeriod": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'boolean') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null,
                    "valueReference": null, "valuePeriod": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Period') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null,
                    "valueBoolean": null, "valueReference": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'RelativeTime') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null,
                    "valueBoolean": null, "valuePeriod": null, "valueReference": null, "valueExpression": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Expression') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null,
                    "valueBoolean": null, "valuePeriod": null, "valueRelativeTime": null, "valueReference": null,
                    "valueUri": null
                }
            })
        }
        if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'uri') {
            setEvidenceVariableDefinitionModifierState(prevState => {
                return {
                    ...prevState, 'valueQuantity': null, 'valueCodeableConcept': null, 'valueRange': null,
                    "valueBoolean": null, "valuePeriod": null, "valueRelativeTime": null, "valueExpression": null,
                    "valueReference": null
                }
            })
        }
    }), [evidenceVariableDefinitionModifierDotValueDatatypeState]);

    useEffect((() => {
        if (Object.keys(evidenceVariableDefinitionModifierState).length > 0) {
            let newEvidenceVariableDefinitionModdifier = {};
            if (evidenceVariableDefinitionModifierState.extension) { newEvidenceVariableDefinitionModdifier.extension = evidenceVariableDefinitionModifierState.extension; }
            if (evidenceVariableDefinitionModifierState.code) { newEvidenceVariableDefinitionModdifier.code = evidenceVariableDefinitionModifierState.code; }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'CodeableConcept' &&
                evidenceVariableDefinitionModifierState.valueCodeableConcept &&
                Object.keys(evidenceVariableDefinitionModifierState.valueCodeableConcept).length > 0) {
                newEvidenceVariableDefinitionModdifier.valueCodeableConcept = evidenceVariableDefinitionModifierState.valueCodeableConcept;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'boolean' &&
                (evidenceVariableDefinitionModifierState.valueBoolean === true || evidenceVariableDefinitionModifierState.valueBoolean === false)) {
                newEvidenceVariableDefinitionModdifier.valueBoolean = evidenceVariableDefinitionModifierState.valueBoolean;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Quantity' &&
                evidenceVariableDefinitionModifierState.valueQuantity &&
                Object.keys(evidenceVariableDefinitionModifierState.valueQuantity).length > 0) {
                newEvidenceVariableDefinitionModdifier.valueQuantity = evidenceVariableDefinitionModifierState.valueQuantity;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Range' &&
                evidenceVariableDefinitionModifierState.valueRange &&
                Object.keys(evidenceVariableDefinitionModifierState.valueRange).length > 0) {
                newEvidenceVariableDefinitionModdifier.valueRange = evidenceVariableDefinitionModifierState.valueRange;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Period' &&
                evidenceVariableDefinitionModifierState.valuePeriod &&
                Object.keys(evidenceVariableDefinitionModifierState.valuePeriod).length > 0) {
                newEvidenceVariableDefinitionModdifier.valuePeriod = evidenceVariableDefinitionModifierState.valuePeriod;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'RelativeTime' &&
                evidenceVariableDefinitionModifierState.valueRelativeTime &&
                Object.keys(evidenceVariableDefinitionModifierState.valueRelativeTime).length > 0) {
                newEvidenceVariableDefinitionModdifier.valueRelativeTime = evidenceVariableDefinitionModifierState.valueRelativeTime;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Reference' &&
                evidenceVariableDefinitionModifierState.valueReference &&
                Object.keys(evidenceVariableDefinitionModifierState.valueReference).length > 0) {
                newEvidenceVariableDefinitionModdifier.valueReference = evidenceVariableDefinitionModifierState.valueReference;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'Expression' &&
                evidenceVariableDefinitionModifierState.valueExpression &&
                Object.keys(evidenceVariableDefinitionModifierState.valueExpression).length > 0) {
                newEvidenceVariableDefinitionModdifier.valueExpression = evidenceVariableDefinitionModifierState.valueExpression;
            }
            if (evidenceVariableDefinitionModifierDotValueDatatypeState === 'uri' &&
                evidenceVariableDefinitionModifierState.valueUri) {
                newEvidenceVariableDefinitionModdifier.valueUri = evidenceVariableDefinitionModifierState.valueUri;
            }
            if (Object.keys(newEvidenceVariableDefinitionModdifier).length === 0) {
                newEvidenceVariableDefinitionModdifier = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceVariableDefinitionModdifier }; });
        }
    }), [evidenceVariableDefinitionModifierState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.code && <span><b>Code: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.code} /></span>}
                {(startingValue.valueCodeableConcept && typeof startingValue.valueCodeableConcept === "object") &&
                    <span><b>Value as CodeableConcept: </b>
                        <DisplayFromFHIRCodeableConcept codeableConcept={startingValue.valueCodeableConcept} /></span>}
                {(startingValue.valueQuantity && typeof startingValue.valueQuantity === "object") &&
                    <span><b>Value as Quantity: </b>{displayStringFromFHIRQuantity(startingValue.valueQuantity)}</span>}
                {(startingValue.valueRange && typeof startingValue.valueRange === "object") &&
                    <span><b>Value as Range: </b>{displayStringFromFHIRRange(startingValue.valueRange)}</span>}
                {(startingValue.valuePeriod && typeof startingValue.valuePeriod === "object") &&
                    <span><b>Value as Period: </b>{displayStringFromFHIRPeriod(startingValue.valuePeriod)}</span>}
                {(startingValue.valueRelativeTime && typeof startingValue.valueRelativeTime === "object") &&
                    <span><b>Value as RelativeTime: </b>{displayStringFromFHIRRelativeTime(startingValue.valueRelativeTime)}</span>}
                {(startingValue.valueReference && typeof startingValue.valueReference === "object") &&
                    <span><b>Value as Reference: </b>
                        <DisplayFromFHIRReference reference={startingValue.valueReference} /></span>}
                {(startingValue.valueExpression && typeof startingValue.valueExpression === "object") &&
                    <span><b>Value as Expression: </b>
                        <DisplayFromFHIRExpression expression={startingValue.valueExpression} /></span>}
                {(startingValue.valueBoolean === true) && <p><b>Value as Boolean: </b>TRUE</p>}
                {(startingValue.valueBoolean === false) && <p><b>Value as Boolean: </b>FALSE</p>}
                {(startingValue.valueUri && typeof startingValue.valueUri === "string") &&
                    <span><b>Value as URI: </b>
                        <DisplayFromFHIRUri uri={startingValue.valueUri} /></span>}
            </div >}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div >
    } else if (Object.keys(evidenceVariableDefinitionModifierState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='code' fieldLabel='Definition Modifier Code'
                    startingValue={evidenceVariableDefinitionModifierState.code}
                    setResourceState={setEvidenceVariableDefinitionModifierState} />
                <DatatypeSelector elementXName='value[x]'
                    allowedDatatypes={EvidenceVariableDefinitionModifierDotValueAllowedDatatypes}
                    datatypeState={evidenceVariableDefinitionModifierDotValueDatatypeState}
                    setDatatypeState={setEvidenceVariableDefinitionModifierDotValueDatatypeState} />
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'CodeableConcept' &&
                    <CodeableConceptEntry elementName='valueCodeableConcept'
                        fieldLabel='Definition Modifier Value as CodeableConcept'
                        startingValue={evidenceVariableDefinitionModifierState.valueCodeableConcept}
                        systemChoices={evidenceVariableDefinitionConceptSystemChoices} systemChoicesOpen={true}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'boolean' &&
                    <BooleanEntry elementName='valueBoolean'
                        fieldLabel='Definition Modifier Value as Boolean'
                        startingValue={evidenceVariableDefinitionModifierState.valueBoolean}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'Quantity' &&
                    <QuantityEntry elementName='valueQuantity'
                        fieldLabel='Definition Modifier Value as Quantity'
                        startingValue={evidenceVariableDefinitionModifierState.valueQuantity}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'Range' &&
                    <RangeEntry elementName='valueRange'
                        fieldLabel='Definition Modifier Value as Range'
                        startingValue={evidenceVariableDefinitionModifierState.valueRange}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'Period' &&
                    <PeriodEntry elementName='valuePeriod'
                        fieldLabel='Definition Modifier Value as Period'
                        startingValue={evidenceVariableDefinitionModifierState.valuePeriod}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'RelativeTime' &&
                    <RelativeTimeEntry elementName='valueRelativeTime'
                        fieldLabel='Definition Modifier Value as RelativeTime'
                        startingValue={evidenceVariableDefinitionModifierState.valueRelativeTime}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'Reference' &&
                    <ReferenceEntry elementName='valueReference'
                        fieldLabel='Definition Modifier Value as Reference'
                        startingValue={evidenceVariableDefinitionModifierState.valueReference} enableCreation={true}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'Expression' &&
                    <ExpressionEntry elementName='valueExpression'
                        fieldLabel='Definition Modifier Value as Expression'
                        startingValue={evidenceVariableDefinitionModifierState.valueExpression}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
                {evidenceVariableDefinitionModifierDotValueDatatypeState === 'uri' &&
                    <UriEntry elementName='valueUri'
                        fieldLabel='Definition Modifier Value as URI'
                        startingValue={evidenceVariableDefinitionModifierState.valueUri}
                        setResourceState={setEvidenceVariableDefinitionModifierState} />}
            </div>
        </>
    }
};

const EvidenceVariableConstraintEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {

    const [evidenceVariableConstraintState, setEvidenceVariableConstraintState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingVariableConstraint = {
            conditional: "", minimumQuantity: "", maximumQuantity: "",
            earliestDateTime: "", latestDateTime: "", minimumStringLength: "", maximumStringLength: "",
            code: "", expression: "", expectedValueSet: "", expectedUnitsValueSet: "", anyValueAllowed: ""
        }
        if (startingValue) {
            if (startingValue.extension) { startingVariableConstraint.extension = startingValue.extension; }
            if (startingValue.conditional) { startingVariableConstraint.conditional = startingValue.conditional; }
            if (startingValue.minimumQuantity) { startingVariableConstraint.minimumQuantity = startingValue.minimumQuantity; }
            if (startingValue.maximumQuantity) { startingVariableConstraint.maximumQuantity = startingValue.maximumQuantity; }
            if (startingValue.earliestDateTime) { startingVariableConstraint.earliestDateTime = startingValue.earliestDateTime; }
            if (startingValue.latestDateTime) { startingVariableConstraint.latestDateTime = startingValue.latestDateTime; }
            if (startingValue.minimumStringLength) { startingVariableConstraint.minimumStringLength = startingValue.minimumStringLength; }
            if (startingValue.maximumStringLength) { startingVariableConstraint.maximumStringLength = startingValue.maximumStringLength; }
            if (startingValue.code) { startingVariableConstraint.code = startingValue.code; }
            if (startingValue.expression) { startingVariableConstraint.expression = startingValue.expression; }
            if (startingValue.expectedValueSet) { startingVariableConstraint.expectedValueSet = startingValue.expectedValueSet; }
            if (startingValue.expectedUnitsValueSet) { startingVariableConstraint.expectedUnitsValueSet = startingValue.expectedUnitsValueSet; }
            if (typeof startingValue.anyValueAllowed === "boolean") {
                startingVariableConstraint.anyValueAllowed = startingValue.anyValueAllowed;
            }
        }
        setEvidenceVariableConstraintState(JSON.parse(JSON.stringify(startingVariableConstraint)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceVariableConstraintState).length > 0) {
            let newEvidenceVariableConstraint = {};
            if (evidenceVariableConstraintState.extension) { newEvidenceVariableConstraint.extension = evidenceVariableConstraintState.extension; }
            if (evidenceVariableConstraintState.conditional) { newEvidenceVariableConstraint.conditional = evidenceVariableConstraintState.conditional; }
            if (evidenceVariableConstraintState.minimumQuantity) { newEvidenceVariableConstraint.minimumQuantity = evidenceVariableConstraintState.minimumQuantity; }
            if (evidenceVariableConstraintState.maximumQuantity) { newEvidenceVariableConstraint.maximumQuantity = evidenceVariableConstraintState.maximumQuantity; }
            if (evidenceVariableConstraintState.earliestDateTime) { newEvidenceVariableConstraint.earliestDateTime = evidenceVariableConstraintState.earliestDateTime; }
            if (evidenceVariableConstraintState.latestDateTime) { newEvidenceVariableConstraint.latestDateTime = evidenceVariableConstraintState.latestDateTime; }
            if (evidenceVariableConstraintState.minimumStringLength) { newEvidenceVariableConstraint.minimumStringLength = evidenceVariableConstraintState.minimumStringLength; }
            if (evidenceVariableConstraintState.maximumStringLength) { newEvidenceVariableConstraint.maximumStringLength = evidenceVariableConstraintState.maximumStringLength; }
            if (evidenceVariableConstraintState.code) { newEvidenceVariableConstraint.code = evidenceVariableConstraintState.code; }
            if (evidenceVariableConstraintState.expression) { newEvidenceVariableConstraint.expression = evidenceVariableConstraintState.expression; }
            if (evidenceVariableConstraintState.expectedValueSet) { newEvidenceVariableConstraint.expectedValueSet = evidenceVariableConstraintState.expectedValueSet; }
            if (evidenceVariableConstraintState.expectedUnitsValueSet) { newEvidenceVariableConstraint.expectedUnitsValueSet = evidenceVariableConstraintState.expectedUnitsValueSet; }
            if (typeof evidenceVariableConstraintState.anyValueAllowed === "boolean") {
                newEvidenceVariableConstraint.anyValueAllowed = evidenceVariableConstraintState.anyValueAllowed;
            }
            if (Object.keys(newEvidenceVariableConstraint).length === 0) {
                newEvidenceVariableConstraint = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceVariableConstraint }; });
        }
    }), [evidenceVariableConstraintState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.conditional && <span>
                    <b>Conditional (constraint applies if): </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.conditional} />
                </span>}
                {(startingValue.minimumQuantity) &&
                    <p><b>Minimum quantity: </b>{displayStringFromFHIRQuantity(startingValue.minimumQuantity)}</p>}
                {(startingValue.maximumQuantity) &&
                    <p><b>Maximum quantity: </b>{displayStringFromFHIRQuantity(startingValue.maximumQuantity)}</p>}
                {(startingValue.earliestDateTime) &&
                    <p><b>Earliest time: </b>{getDateTimeDisplay(startingValue.earliestDateTime)}</p>}
                {(startingValue.latestDateTime) &&
                    <p><b>Latest time: </b>{getDateTimeDisplay(startingValue.latestDateTime)}</p>}
                {(startingValue.minimumStringLength || startingValue.minimumStringLength === 0) &&
                    <p><b>Minimum string length: </b>{startingValue.minimumStringLength.toString()} characters</p>}
                {(startingValue.maximumStringLength) &&
                    <p><b>Maximum string length: </b>{startingValue.maximumStringLength.toString()} characters</p>}
                {startingValue.code && <span>
                    <b>Rule (as CodeableConcept): </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.code} />
                </span>}
                {startingValue.expression && <span>
                    <b>Rule (as Expression): </b><DisplayFromFHIRExpression expression={startingValue.expression} />
                </span>}
                {startingValue.expectedValueSet && <span>
                    <b>Expected values: </b><DisplayFromFHIRReference reference={startingValue.expectedValueSet} />
                </span>}
                {startingValue.expectedUnitsValueSet && <span>
                    <b>Expected units: </b><DisplayFromFHIRReference reference={startingValue.expectedUnitsValueSet} />
                </span>}
                {startingValue.anyValueAllowed === true && <p><b>Any value allowed: </b> TRUE</p>}
                {startingValue.anyValueAllowed === false && <p><b>Any value allowed: </b> False</p>}
            </div >}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div >
    } else if (Object.keys(evidenceVariableConstraintState).length > 0) {
        return <>
            <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
            <div style={{ marginLeft: "24px" }}>
                <CodeableConceptEntry elementName='conditional'
                    fieldLabel='Conditional (constraint applies if)'
                    startingValue={evidenceVariableConstraintState.conditional}
                    setResourceState={setEvidenceVariableConstraintState} />
                <QuantityEntry elementName='minimumQuantity' fieldLabel='Minimum quantity'
                    startingValue={evidenceVariableConstraintState.minimumQuantity}
                    setResourceState={setEvidenceVariableConstraintState} />
                <QuantityEntry elementName='maximumQuantity' fieldLabel='Maximum quantity'
                    startingValue={evidenceVariableConstraintState.maximumQuantity}
                    setResourceState={setEvidenceVariableConstraintState} />
                <DateTimeEntry elementName='earliestDateTime' fieldLabel='Earliest time'
                    startingValue={evidenceVariableConstraintState.earliestDateTime}
                    setResourceState={setEvidenceVariableConstraintState} />
                <DateTimeEntry elementName='latestDateTime' fieldLabel='Latest time'
                    startingValue={evidenceVariableConstraintState.latestDateTime}
                    setResourceState={setEvidenceVariableConstraintState} />
                <UnsignedIntEntry elementName='minimumStringLength' fieldLabel='Minimum string length'
                    startingValue={evidenceVariableConstraintState.minimumStringLength}
                    setResourceState={setEvidenceVariableConstraintState} />
                <PositiveIntEntry elementName='maximumStringLength' fieldLabel='Maximum string length'
                    startingValue={evidenceVariableConstraintState.maximumStringLength}
                    setResourceState={setEvidenceVariableConstraintState} />
                <CodeableConceptEntry elementName='code'
                    fieldLabel='Rule (as CodeableConcept)'
                    startingValue={evidenceVariableConstraintState.code}
                    setResourceState={setEvidenceVariableConstraintState} />
                <ExpressionEntry elementName='expression'
                    fieldLabel='Rule (as Expression)'
                    startingValue={evidenceVariableConstraintState.expression}
                    setResourceState={setEvidenceVariableConstraintState} />
                <ReferenceEntry elementName='expectedValueSet'
                    fieldLabel='Expected values' enableCreation={true}
                    startingResourceType="ValueSet"
                    referencedResourceTypes={["ValueSet"]} startCollapsed
                    startingValue={evidenceVariableConstraintState.expectedValueSet}
                    setResourceState={setEvidenceVariableConstraintState} />
                <ReferenceEntry elementName='expectedUnitsValueSet'
                    fieldLabel='Expected units' enableCreation={true}
                    startingResourceType="ValueSet"
                    referencedResourceTypes={["ValueSet"]} startCollapsed
                    startingValue={evidenceVariableConstraintState.expectedUnitsValueSet}
                    setResourceState={setEvidenceVariableConstraintState} />
                <BooleanEntry elementName='anyValueAllowed'
                    fieldLabel='Any value allowed' storeFalse
                    startingValue={evidenceVariableConstraintState.anyValueAllowed ?? null}
                    setResourceState={setEvidenceVariableConstraintState} />
            </div>
        </>
    }
}

const EvidenceVariableDataStorageEntry = ({ elementName, fieldLabel, startingValue,
    setResourceState, startCollapsed }) => {

    const [evidenceVariableDataStorageState, setEvidenceVariableDataStorageState] = useState({});
    const [startingEvidenceVariableDataStorageState, setStartingEvidenceVariableDataStorageState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingVariableDataStorage = {
            datatype: "", path: "", delimiter: "", component: ""
        }
        if (startingValue) {
            if (startingValue.extension) { startingVariableDataStorage.extension = startingValue.extension; }
            if (startingValue.datatype) { startingVariableDataStorage.datatype = startingValue.datatype; }
            if (startingValue.path) { startingVariableDataStorage.path = startingValue.path; }
            if (startingValue.delimiter) { startingVariableDataStorage.delimiter = startingValue.delimiter; }
            if (startingValue.component) { startingVariableDataStorage.component = startingValue.component; }
        }
        setEvidenceVariableDataStorageState(JSON.parse(JSON.stringify(startingVariableDataStorage)));
        setStartingEvidenceVariableDataStorageState(JSON.parse(JSON.stringify(startingVariableDataStorage)));
    }, []);

    useEffect((() => {
        if (Object.keys(evidenceVariableDataStorageState).length > 0 &&
            JSON.stringify(evidenceVariableDataStorageState) !== JSON.stringify(startingEvidenceVariableDataStorageState)) {
            let newEvidenceVariableDataStorage = {};
            if (evidenceVariableDataStorageState.extension) { newEvidenceVariableDataStorage.extension = evidenceVariableDataStorageState.extension; }
            if (evidenceVariableDataStorageState.datatype) { newEvidenceVariableDataStorage.datatype = evidenceVariableDataStorageState.datatype; }
            if (evidenceVariableDataStorageState.path) { newEvidenceVariableDataStorage.path = evidenceVariableDataStorageState.path; }
            if (evidenceVariableDataStorageState.delimiter) { newEvidenceVariableDataStorage.delimiter = evidenceVariableDataStorageState.delimiter; }
            if (evidenceVariableDataStorageState.component?.length > 0) { newEvidenceVariableDataStorage.component = evidenceVariableDataStorageState.component; }
            if (Object.keys(newEvidenceVariableDataStorage).length === 0) {
                newEvidenceVariableDataStorage = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newEvidenceVariableDataStorage }; });
        }
    }), [evidenceVariableDataStorageState]);

    if (Object.keys(evidenceVariableDataStorageState).length > 0) {
        if (startCollapsedState) {
            return <div>
                <b>{fieldLabel}: </b>
                {startingValue && <div style={{ marginLeft: "24px" }}>
                    {startingValue.datatype && <span><b>Datatype: </b><DisplayFromFHIRCodeableConcept codeableConcept={startingValue.datatype} /></span>}
                    {(startingValue.path && typeof startingValue.path === "string") && <p><b>Path: </b>{startingValue.path}</p>}
                    {(startingValue.delimiter && typeof startingValue.delimiter === "string") && <p><b>Delimiter: </b>{startingValue.delimiter}</p>}
                    {(Array.isArray(startingValue.component) && startingValue.component.length > 0) && <div>
                        <p><b>Components</b></p>
                        {startingValue.component.map((part, partIndex) => {
                            return <div key={partIndex} style={{ marginLeft: "24px" }}>
                                {part.datatype && <span><b>Datatype: </b><DisplayFromFHIRCodeableConcept codeableConcept={part.datatype} /></span>}
                                {(part.path && typeof part.path === "string") && <p><b>Path: </b>{part.path}</p>}
                                {(part.delimiter && typeof part.delimiter === "string") && <p><b>Delimiter: </b>{part.delimiter}</p>}
                                {(Array.isArray(part.component) && part.component.length > 0) && <p>has components</p>}
                            </div>
                        })}
                    </div>}
                </div >}
                &nbsp;&nbsp;
                <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
            </div >
        } else {
            return <>
                <p style={{ marginBottom: "0px" }}><b>{fieldLabel}: </b></p>
                <div style={{ marginLeft: "24px" }}>
                    <CodeableConceptEntry elementName='datatype' fieldLabel='Datatype'
                        startingValue={evidenceVariableDataStorageState.datatype}
                        setResourceState={setEvidenceVariableDataStorageState} />
                    <StringEntry elementName='path' fieldLabel='Path'
                        startingValue={evidenceVariableDataStorageState.path}
                        setResourceState={setEvidenceVariableDataStorageState} />
                    <StringEntry elementName='delimiter' fieldLabel='Delimiter'
                        startingValue={evidenceVariableDataStorageState.delimiter}
                        setResourceState={setEvidenceVariableDataStorageState} />
                    <ArrayEntry datatype='EvidenceVariableDataStorage'
                        elementName='component' fieldLabel='Component' startEmptyArrayClosed
                        deletable deletableArray={true}
                        startingValue={evidenceVariableDataStorageState.component}
                        setResourceState={setEvidenceVariableDataStorageState} />
                </div>
            </>
        }
    }
}

const EvidenceVariableDisplay = ({ foi }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceChanges = useSelector(state => selectAllResourceChanges(state));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const displayTitle = parentResourceDetail?.displayTitle;
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    const olderVersionFhirString = useSelector(state => selectOlderVersionFhirString(state));
    let isVariableDefinitionProfile;
    let isGroupAssignmentProfile;
    let isParticipantFlowEvidenceVariableProfile;
    let isParticipantFlowReasonEvidenceVariableProfile;
    let isDichotomousIntendedOutcomeProfile;
    if (resourceJson.meta?.profile?.length) {
        for (const profile of resourceJson.meta.profile) {
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/variable-definition") {
                isVariableDefinitionProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/group-assignment") {
                isGroupAssignmentProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-evidence-variable") {
                isParticipantFlowEvidenceVariableProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-reason-evidence-variable") {
                isParticipantFlowReasonEvidenceVariableProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/dichotomous-intended-outcome") {
                isDichotomousIntendedOutcomeProfile = true;
            }
        }
    }

    let toolDisplayName = "EvidenceVariable";
    if (isVariableDefinitionProfile) { toolDisplayName = "VariableDefinition"; }
    if (isGroupAssignmentProfile) { toolDisplayName = "GroupAssignment"; }
    if (isParticipantFlowEvidenceVariableProfile) { toolDisplayName = "ParticipantFlowEvidenceVariable"; }
    if (isParticipantFlowReasonEvidenceVariableProfile) { toolDisplayName = "ParticipantFlowReasonEvidenceVariable"; }
    if (isDichotomousIntendedOutcomeProfile) { toolDisplayName = "DichotomousIntendedOutcome"; }

    const [evidenceVariableResourceState, setEvidenceVariableResourceState] = useState({});
    const [handlingDetailState, setHandlingDetailState] = useState({});

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR " + toolDisplayName + " - " + displayTitle));
        dispatch(changeTopNavigationElements(["Summary", "Definition", "Data Handling"]));
        if (viewingOlderVersion && olderVersionFhirString) {
            try {
                const olderVersionJson = JSON.parse(olderVersionFhirString);
                setEvidenceVariableResourceState(olderVersionJson);
                let handlingDetail;
                if (Array.isArray(olderVersionJson.extension)) {
                    for (let extension of olderVersionJson.extension) {
                        if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-variable-handling-detail") {
                            handlingDetail = extension.valueCodeableConcept;
                            break;
                        }
                    }
                }
                setHandlingDetailState({ "handlingDetail": handlingDetail });
            } catch {
                alert("Error viewing JSON of older version.");
            }
        } else if (resourceJson) {
            let handlingDetail;
            if (Array.isArray(resourceJson.extension)) {
                for (let extension of resourceJson.extension) {
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-variable-handling-detail") {
                        handlingDetail = extension.valueCodeableConcept;
                        break;
                    }
                }
            }
            setHandlingDetailState({ "handlingDetail": handlingDetail });
            let tempJson = JSON.parse(JSON.stringify(resourceJson));
            tempJson.handling = convertEvidenceVariableHandlingToCodeableConcept(tempJson.handling, handlingDetail);
            setEvidenceVariableResourceState(tempJson);
        }
    }, [resourceJson]);

    useEffect(() => {
        dispatch(changeTool("FEvIR®: EvidenceVariable " + (editMode ? "Builder" : "Viewer")));
    }, [editMode]);

    useEffect(() => {
        if (handlingDetailState.handlingDetail) {
            setEvidenceVariableResourceState(prevState => {
                let newExtension = prevState.extension ? JSON.parse(JSON.stringify(prevState.extension)) : [];
                let handlingExtensionFound = false;
                for (let extension of newExtension) {
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-variable-handling-detail") {
                        extension.valueCodeableConcept = handlingDetailState.handlingDetail;
                        handlingExtensionFound = true;
                        break;
                    }
                }
                if (!handlingExtensionFound) {
                    newExtension.push({
                        "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-variable-handling-detail",
                        "valueCodeableConcept": handlingDetailState.handlingDetail
                    })
                }
                return { ...prevState, extension: newExtension };
            })
        }
    }, [handlingDetailState]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "extension", "ArrayOfExtension", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.extension]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateNarrativeElement(evidenceVariableResourceState, "text", "Narrative", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.text]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.title;
            previousFinalValue = newResourceDetail.revisedResourceJson.title;
            newResourceDetail.revisedResourceJson.title = evidenceVariableResourceState.title;
            newResourceDetail.displayTitle = evidenceVariableResourceState.title ||
                evidenceVariableResourceState.name ||
                evidenceVariableResourceState.shortTitle || newResourceDetail.displayTitle;
            if (evidenceVariableResourceState.title !== undefined &&
                previousFinalValue !== evidenceVariableResourceState.title) {
                console.log("resourceUpdate for EvidenceVariable.title");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "string",
                    "title",
                    previousInitialValue,
                    evidenceVariableResourceState.title);
            }
        }
    }, [evidenceVariableResourceState.title]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.name;
            previousFinalValue = newResourceDetail.revisedResourceJson.name;
            newResourceDetail.revisedResourceJson.name = evidenceVariableResourceState.name;
            newResourceDetail.displayTitle = evidenceVariableResourceState.title ||
                evidenceVariableResourceState.name ||
                evidenceVariableResourceState.shortTitle || newResourceDetail.displayTitle;
            if (evidenceVariableResourceState.name !== undefined &&
                previousFinalValue !== evidenceVariableResourceState.name) {
                console.log("resourceUpdate for EvidenceVariable.name");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "string",
                    "name",
                    previousInitialValue,
                    evidenceVariableResourceState.name);
            }
        }
    }, [evidenceVariableResourceState.name]);

    useEffect(() => {
        if (editMode && resourceJson) {
            let newResourceDetail = JSON.parse(JSON.stringify(parentResourceDetail));
            let previousInitialValue = null;
            let previousFinalValue = null;
            previousInitialValue = newResourceDetail.resourceJson.shortTitle;
            previousFinalValue = newResourceDetail.revisedResourceJson.shortTitle;
            newResourceDetail.revisedResourceJson.shortTitle = evidenceVariableResourceState.shortTitle;
            newResourceDetail.displayTitle = evidenceVariableResourceState.title ||
                evidenceVariableResourceState.name ||
                evidenceVariableResourceState.shortTitle || newResourceDetail.displayTitle;
            if (evidenceVariableResourceState.shortTitle !== undefined &&
                previousFinalValue !== evidenceVariableResourceState.shortTitle) {
                console.log("resourceUpdate for EvidenceVariable.shortTitle");
                dispatch(resourceUpdated(newResourceDetail));
                updateChangeReport(dispatch, resourceChanges, newResourceDetail.id,
                    "string",
                    "title",
                    previousInitialValue,
                    evidenceVariableResourceState.shortTitle);
            }
        }
    }, [evidenceVariableResourceState.shortTitle]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "description", "markdown", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.description]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "note", "ArrayOfAnnotation", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.note]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "actual", "boolean", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.actual]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "definition", "CodeableReference", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.definition]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "definitionModifier", "ArrayOfEvidenceVariableDefinitionModifier", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.definitionModifier]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "handling", "CodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.handling]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "category", "ArrayOfEvidenceVariableCategory", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.category]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "conditional", "Expression", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.conditional]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "classifier", "ArrayOfCodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.classifier]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "dataStorage", "ArrayOfEvidenceVariableDataStorage", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.dataStorage]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "timing", "RelativeTime", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.timing]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "period", "Period", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.period]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "constraint", "ArrayOfEvidenceVariableConstraint", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.constraint]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "missingDataMeaning", "ArrayOfCodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.missingDataMeaning]);

    useEffect(() => {
        if (editMode && resourceJson) {
            updateElement(evidenceVariableResourceState, "unacceptableDataHandling", "ArrayOfCodeableConcept", parentResourceDetail,
                resourceChanges, dispatch);
        }
    }, [evidenceVariableResourceState.unacceptableDataHandling]);

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div>
        {evidenceVariableResourceState.id && <>
            <div style={{ marginTop: "12px" }}>
                <h3 id="summary">Summary</h3>
                <div style={{ marginLeft: "24px" }}>
                    {
                        editMode ?
                            <>
                                <StringEntry elementName='title' fieldLabel='Title'
                                    startingValue={evidenceVariableResourceState.title} setResourceState={setEvidenceVariableResourceState} />
                                <StringEntry elementName='shortTitle' fieldLabel='Short title'
                                    startingValue={evidenceVariableResourceState.shortTitle} setResourceState={setEvidenceVariableResourceState} />
                                <StringEntry elementName='name' fieldLabel='Name'
                                    startingValue={evidenceVariableResourceState.name} setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.title && <p><b>Title: </b>{evidenceVariableResourceState.title}</p>}
                                {evidenceVariableResourceState.shortTitle && <p><b>Short title: </b>{evidenceVariableResourceState.shortTitle}</p>}
                                {evidenceVariableResourceState.name && <p><b>Name: </b>{evidenceVariableResourceState.name}</p>}
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <MarkdownEntry elementName='description' fieldLabel='Description'
                                    startCollapsed
                                    startingValue={evidenceVariableResourceState.description} setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.description && <div>
                                    <b>Description: </b><DisplayFromFHIRMarkdown markdown={evidenceVariableResourceState.description} />
                                    <br /><br />
                                </div>}
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='Annotation' elementName='note' fieldLabel='Note'
                                    startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.note} setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {Array.isArray(evidenceVariableResourceState.note) &&
                                    evidenceVariableResourceState.note.map((note, noteIndex) => {
                                        return <div key={noteIndex}>
                                            <b>Note: </b><DisplayFromFHIRAnnotation annotation={note} />
                                            <br /><br />
                                        </div>
                                    })}
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <BooleanEntry elementName='actual' fieldLabel='Actual'
                                    startingValue={evidenceVariableResourceState.actual} setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {(typeof evidenceVariableResourceState.actual === "boolean") &&
                                    <p><b>Actual:</b> {displayStringFromFHIRBoolean(evidenceVariableResourceState.actual)}</p>}
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <h4>Narrative Summary</h4>
                                <div style={{ marginLeft: "24px" }}>
                                    <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                                        generatedNarrative={generateNarrativeForEvidenceVariableResource(evidenceVariableResourceState)}
                                        startCollapsed
                                        startingValue={evidenceVariableResourceState.text} setResourceState={setEvidenceVariableResourceState} />
                                </div>
                            </>
                            :
                            <>
                                {(evidenceVariableResourceState.text?.div && evidenceVariableResourceState.text.status && evidenceVariableResourceState.text.status !== "empty") && <>
                                    <h4>Narrative Summary:</h4>
                                    <div style={{ marginLeft: "24px" }}>
                                        <DisplayFromFHIRXhtml xhtml={evidenceVariableResourceState.text.div} />
                                    </div>
                                </>}
                            </>
                    }
                </div>
                <h3 id="definition">Definition</h3>
                <div style={{ marginLeft: "24px" }}>
                    {
                        editMode ?
                            <>
                                {(isGroupAssignmentProfile &&
                                    evidenceVariableResourceState.definition?.concept?.coding?.[0]?.code !== "defined-in-handling-and-category") &&
                                    <p><b>The definition.concept.coding[0].code element does not have a value of "defined-in-handling-and-category", but it is required when using the GroupAssignment Profile.</b></p>
                                }
                                <CodeableReferenceEntry elementName='definition' fieldLabel='Variable Definition'
                                    referencedResourceTypes={evidenceVariableDotDefinitionResourceTypes} startCollapsed
                                    enableCreation={true} systemChoices={evidenceVariableDefinitionConceptSystemChoices} systemChoicesOpen={true}
                                    startingValue={evidenceVariableResourceState.definition} setResourceState={setEvidenceVariableResourceState} />
                                {evidenceVariableResourceState.characteristicDefinition && <>
                                    <p>The characteristicDefinition element value (displayed below) should be moved to a definition.reference element to match the current FHIR EvidenceVariable Resource.</p>
                                    <DisplayFromFHIRReference reference={evidenceVariableResourceState.characteristicDefinition} />
                                </>}
                                {evidenceVariableResourceState.characteristic &&
                                    <p>The characteristic element has content (based on an older version of the FHIR EvidenceVariable Resource) and should be restructured to match the current FHIR EvidenceVariable Resource.</p>}
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.definition && <>
                                    <DisplayFromFHIRCodeableReference codeableReference={evidenceVariableResourceState.definition} />
                                </>}
                                {evidenceVariableResourceState.characteristicDefinition && <>
                                    <p>No definition element (The displayed value below from a characteristicDefinition element is based on an older version of the FHIR EvidenceVariable Resource.)</p>
                                    <DisplayFromFHIRReference reference={evidenceVariableResourceState.characteristicDefinition} />
                                </>}
                                {evidenceVariableResourceState.characteristic &&
                                    <p>No definition element (View the JSON for a characteristic element (based on an older version of the FHIR EvidenceVariable Resource).)</p>}
                                {(!evidenceVariableResourceState.definition && !evidenceVariableResourceState.characteristic && !evidenceVariableResourceState.characteristicDefinition) &&
                                    <p>No definition element (No structured definition.)</p>}
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='EvidenceVariableDefinitionModifier' elementName='definitionModifier'
                                    fieldLabel='Definition Modifier' startEmptyArrayClosed={true} deletable={true} deletableArray={true} startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.definitionModifier} setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {Array.isArray(evidenceVariableResourceState.definitionModifier) &&
                                    evidenceVariableResourceState.definitionModifier.map((modifier, modifierIndex) => {
                                        return <div key={modifierIndex}>
                                            <h4>Definition Modifier</h4>
                                            <DisplayFromFHIRCodeableConcept codeableConcept={modifier.code} />
                                            <span> matching </span>
                                            {modifier.valueCodeableConcept && <DisplayFromFHIRCodeableConcept codeableConcept={modifier.valueCodeableConcept} />}
                                            {modifier.valueQuantity && displayStringFromFHIRQuantity(modifier.valueQuantity)}
                                            {modifier.valueRange && displayStringFromFHIRRange(modifier.valueRange)}
                                            {modifier.valuePeriod && displayStringFromFHIRPeriod(modifier.valuePeriod)}
                                            {modifier.valueRelativeTime && displayStringFromFHIRRelativeTime(modifier.valueRelativeTime)}
                                            {modifier.valueReference && <DisplayFromFHIRReference reference={modifier.valueReference} />}
                                            {modifier.valueExpression && <DisplayFromFHIRExpression expression={modifier.valueExpression} />}
                                            {modifier.valueUri && <DisplayFromFHIRUri uri={modifier.valueUri} />}
                                            {modifier.valueBoolean === true && <span>TRUE</span>}
                                            {modifier.valueBoolean === false && <span>FALSE</span>}
                                        </div>
                                    })}
                            </>
                    }
                </div>
                <h3 id="data-handling">Data Handling</h3>
                <div style={{ marginLeft: "24px" }}>
                    {
                        editMode ?
                            <>
                                {(isVariableDefinitionProfile && !evidenceVariableResourceState.handling) &&
                                    <p><b>There is no data in the handling element, but it is required when using the VariableDefinition Profile.</b></p>
                                }
                                {(isDichotomousIntendedOutcomeProfile &&
                                    (evidenceVariableResourceState.handling !== "boolean" &&
                                        evidenceVariableResourceState.handling?.coding?.[0]?.code !== "boolean"
                                    )) &&
                                    <p><b>There handling element does not have a value of 'boolean', but it is required when using the DichotomousIntendedOutcome Profile.</b></p>
                                }
                                {(isParticipantFlowEvidenceVariableProfile &&
                                    (evidenceVariableResourceState.handling !== "boolean" &&
                                        evidenceVariableResourceState.handling?.coding?.[0]?.code !== "boolean"
                                    )) &&
                                    <p><b>There handling element does not have a value of 'boolean', but it is required when using the ParticipantFlowEvidenceVariable Profile.</b></p>
                                }
                                {(isParticipantFlowReasonEvidenceVariableProfile &&
                                    (evidenceVariableResourceState.handling !== "polychotomous" &&
                                        evidenceVariableResourceState.handling?.coding?.[0]?.code !== "polychotomous"
                                    )) &&
                                    <p><b>There handling element does not have a value of 'polychotomous', but it is required when using the ParticipantFlowReasonEvidenceVariable Profile.</b></p>
                                }
                                <CodeableConceptEntry elementName='handling' fieldLabel='Handling'
                                    startingValue={evidenceVariableResourceState.handling}
                                    setResourceState={setEvidenceVariableResourceState}
                                    codeableConceptLevelValueSet={evidenceVariableDotHandlingValueSet} />
                                {evidenceVariableResourceState.handling === "extension" &&
                                    <CodeableConceptEntry elementName='handlingDetail'
                                        fieldLabel='Handling Detail' startCollapsed={true}
                                        startingValue={handlingDetailState.handlingDetail}
                                        setResourceState={setHandlingDetailState} />}
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.handling
                                    ?
                                    <>{typeof evidenceVariableResourceState.handling === "string" ?
                                        <p><b>Handling: </b>{evidenceVariableResourceState.handling}{handlingDetailState?.handlingDetail && " - " + displayStringFromFHIRCodeableConcept(handlingDetailState.handlingDetail)}</p>
                                        :
                                        <p><b>Handling: </b>{simpleDisplayStringFromFHIRCodeableConcept(evidenceVariableResourceState.handling)}</p>
                                    }</>
                                    :
                                    <p><b>Handling: </b>No handling data (No classification of boolean, continuous, dichotomous, ordinal, polychotomous, or extension).</p>
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                {(isGroupAssignmentProfile &&
                                    evidenceVariableResourceState.category?.length < 2) &&
                                    <p><b>The category element does not have at least 2 values, but it is required when using the GroupAssignment Profile.</b></p>
                                }
                                <ArrayEntry datatype='EvidenceVariableCategory' elementName='category'
                                    fieldLabel='Category (value option for categorical variables)' startEmptyArrayClosed={true}
                                    deletable={true} deletableArray={true} startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.category} setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {(Array.isArray(evidenceVariableResourceState.category) && evidenceVariableResourceState.category.length > 0) &&
                                    <Table>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>Name</Table.HeaderCell>
                                                <Table.HeaderCell>Value</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {evidenceVariableResourceState.category.map((category, categoryIndex) => {
                                                return <Table.Row key={categoryIndex}>
                                                    <Table.Cell style={{ verticalAlign: "top", width: "25%" }}>
                                                        {(category.name && typeof category.name === "string") && category.name}
                                                    </Table.Cell>
                                                    <Table.Cell style={{ verticalAlign: "top" }}>
                                                        {category.valueCodeableConcept && <DisplayFromFHIRCodeableConcept codeableConcept={category.valueCodeableConcept} />}
                                                        {category.valueQuantity && displayStringFromFHIRQuantity(category.valueQuantity)}
                                                        {category.valueRange && displayStringFromFHIRRange(category.valueRange)}
                                                        {category.valueReference && <DisplayFromFHIRReference reference={category.valueReference} />}
                                                    </Table.Cell>
                                                </Table.Row>
                                            })}
                                        </Table.Body>
                                    </Table>
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ExpressionEntry elementName='conditional' fieldLabel='Conditional (measured if)'
                                    startingValue={evidenceVariableResourceState.conditional}
                                    setResourceState={setEvidenceVariableResourceState}
                                    startCollapsed />
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.conditional &&
                                    <span>
                                        <b>Conditional (measured if): </b>
                                        <DisplayFromFHIRExpression expression={evidenceVariableResourceState.conditional} />
                                        <br />
                                    </span>
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='CodeableConcept' elementName='classifier'
                                    fieldLabel='Classifier' startEmptyArrayClosed={true}
                                    deletable={true} deletableArray={true} startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.classifier}
                                    setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {Array.isArray(evidenceVariableResourceState.classifier) &&
                                    evidenceVariableResourceState.classifier.map((classifier, itemIndex) => {
                                        return <div key={itemIndex}>
                                            <b>Classifier: </b>
                                            <DisplayFromFHIRCodeableConcept codeableConcept={classifier} />
                                            <br /><br />
                                        </div>
                                    })
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='EvidenceVariableDataStorage' elementName='dataStorage'
                                    fieldLabel='Data storage' startEmptyArrayClosed={true}
                                    deletable={true} deletableArray={true} startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.dataStorage}
                                    setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {Array.isArray(evidenceVariableResourceState.dataStorage) &&
                                    evidenceVariableResourceState.dataStorage.map((dataStorage, itemIndex) => {
                                        return <div key={itemIndex}>
                                            <h4>Data storage</h4>
                                            <div style={{ marginLeft: "24px" }}>
                                                {dataStorage.datatype &&
                                                    <span>
                                                        <b>Datatype: </b>
                                                        <DisplayFromFHIRCodeableConcept codeableConcept={dataStorage.datatype} />
                                                    </span>
                                                }
                                                {dataStorage.path &&
                                                    <p><b>Path: </b>{dataStorage.path}</p>
                                                }
                                                {dataStorage.delimiter &&
                                                    <p><b>Delimiter: </b>{dataStorage.delimiter}</p>
                                                }
                                                {Array.isArray(dataStorage.component) &&
                                                    dataStorage.component.map((part, partIndex) => {
                                                        return <div key={partIndex}>
                                                            <h5>Component</h5>
                                                            <div style={{ marginLeft: "24px" }}>
                                                                {part.datatype &&
                                                                    <span>
                                                                        <b>Datatype: </b>
                                                                        <DisplayFromFHIRCodeableConcept codeableConcept={part.datatype} />
                                                                    </span>
                                                                }
                                                                {part.path &&
                                                                    <p><b>Path: </b>{part.path}</p>
                                                                }
                                                                {part.delimiter &&
                                                                    <p><b>Delimiter: </b>{part.delimiter}</p>
                                                                }
                                                                {(Array.isArray(part.component) && part.component.length) &&
                                                                    <p>has components</p>}
                                                            </div>
                                                        </div>
                                                    })}
                                            </div>
                                            <br />
                                        </div>
                                    })
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <RelativeTimeEntry elementName='timing' fieldLabel='Timing'
                                    startingValue={evidenceVariableResourceState.timing}
                                    setResourceState={setEvidenceVariableResourceState}
                                    startCollapsed />
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.timing &&
                                    <p><b>Timing: </b>{displayStringFromFHIRRelativeTime(evidenceVariableResourceState.timing)}</p>
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <PeriodEntry elementName='period' fieldLabel='Timing (Dates)'
                                    startingValue={evidenceVariableResourceState.period} setResourceState={setEvidenceVariableResourceState}
                                    startCollapsed />
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.period &&
                                    <p><b>Timing (Dates): </b>{displayStringFromFHIRPeriod(evidenceVariableResourceState.period)}</p>
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='EvidenceVariableConstraint' elementName='constraint'
                                    fieldLabel='Constraint' startEmptyArrayClosed={true}
                                    deletable={true} deletableArray={true} startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.constraint}
                                    setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {Array.isArray(evidenceVariableResourceState.constraint) &&
                                    evidenceVariableResourceState.constraint.map((constraint, itemIndex) => {
                                        return <div key={itemIndex}>
                                            <h4>Constraint</h4>
                                            <div style={{ marginLeft: "24px" }}>
                                                {constraint.conditional &&
                                                    <span>
                                                        <b>Conditional (constraint applies if): </b>
                                                        <DisplayFromFHIRCodeableConcept codeableConcept={constraint.conditional} />
                                                        <br /> <br />
                                                    </span>
                                                }
                                                {constraint.minimumQuantity &&
                                                    <p><b>Minimum quantity: </b>{displayStringFromFHIRQuantity(constraint.minimumQuantity)}</p>
                                                }
                                                {constraint.maximumQuantity &&
                                                    <p><b>Maximum quantity: </b>{displayStringFromFHIRQuantity(constraint.maximumQuantity)}</p>
                                                }
                                                {constraint.earliestDateTime &&
                                                    <p><b>Earliest time: </b>{getDateTimeDisplay(constraint.earliestDateTime)}</p>
                                                }
                                                {constraint.latestDateTime &&
                                                    <p><b>Latest time: </b>{getDateTimeDisplay(constraint.latestDateTime)}</p>
                                                }
                                                {(constraint.minimumStringLength || constraint.minimumStringLength === 0) &&
                                                    <p><b>Minimum string length: </b>{constraint.minimumStringLength.toString()} characters</p>
                                                }
                                                {(constraint.maximumStringLength) &&
                                                    <p><b>Maximum string length: </b>{constraint.maximumStringLength.toString()} characters</p>
                                                }
                                                {constraint.code &&
                                                    <span>
                                                        <b>Rule: </b>
                                                        <DisplayFromFHIRCodeableConcept codeableConcept={constraint.code} />
                                                        <br /> <br />
                                                    </span>
                                                }
                                                {constraint.expression &&
                                                    <span>
                                                        <b>Rule: </b>
                                                        <DisplayFromFHIRExpression expression={constraint.expression} />
                                                        <br />
                                                    </span>
                                                }
                                                {constraint.expectedValueSet &&
                                                    <span>
                                                        <b>Expected values: </b>
                                                        <DisplayFromFHIRReference reference={constraint.expectedValueSet} />
                                                        <br /><br />
                                                    </span>
                                                }
                                                {constraint.expectedUnitsValueSet &&
                                                    <span>
                                                        <b>Expected units: </b>
                                                        <DisplayFromFHIRReference reference={constraint.expectedUnitsValueSet} />
                                                        <br /><br />
                                                    </span>
                                                }
                                                {constraint.anyValueAllowed === true &&
                                                    <p><b>Any value allowed: </b>TRUE</p>
                                                }
                                                {constraint.anyValueAllowed === false &&
                                                    <p><b>Any value allowed: </b>FALSE</p>
                                                }
                                            </div>
                                            <br />
                                        </div>
                                    })
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='CodeableConcept' elementName='missingDataMeaning'
                                    fieldLabel='Missing data' startCollapsed={true}
                                    startEmptyArrayClosed={true} deletable={true} deletableArray={true}
                                    startingValue={evidenceVariableResourceState.missingDataMeaning}
                                    setResourceState={setEvidenceVariableResourceState} />
                            </>
                            :
                            <>
                                {evidenceVariableResourceState.missingDataMeaning &&
                                    <>
                                        {Array.isArray(evidenceVariableResourceState.missingDataMeaning) ?
                                            evidenceVariableResourceState.missingDataMeaning.map((missingDataMeaning, itemIndex) => {
                                                return <div key={itemIndex}>
                                                    <b>Missing data: </b>
                                                    <DisplayFromFHIRCodeableConcept codeableConcept={missingDataMeaning} />
                                                    <br /><br /></div>
                                            })
                                            :
                                            <span>
                                                <b>Missing data: </b>
                                                <DisplayFromFHIRCodeableConcept codeableConcept={evidenceVariableResourceState.missingDataMeaning} />
                                                <br /><br />
                                            </span>
                                        }
                                    </>
                                }
                            </>
                    }
                    {
                        editMode ?
                            <>
                                <ArrayEntry datatype='CodeableConcept' elementName='unacceptableDataHandling'
                                    fieldLabel='Unacceptable data handling' startEmptyArrayClosed={true}
                                    deletable={true} deletableArray={true}
                                    startCollapsed={true}
                                    startingValue={evidenceVariableResourceState.unacceptableDataHandling}
                                    setResourceState={setEvidenceVariableResourceState} /></>
                            :
                            <>
                                {Array.isArray(evidenceVariableResourceState.unacceptableDataHandling) &&
                                    evidenceVariableResourceState.unacceptableDataHandling.map((unacceptableDataHandling, itemIndex) => {
                                        return <div key={itemIndex}>
                                            <b>Unacceptable data handling: </b>
                                            <DisplayFromFHIRCodeableConcept codeableConcept={unacceptableDataHandling} />
                                            <br /><br />
                                        </div>
                                    })
                                }
                            </>
                    }
                </div>
            </div>
        </>}
    </div >
}

export default EvidenceVariableDisplay;
export {
    evidenceVariableDefinitionConceptSystemChoices, evidenceVariableDotHandlingValueSet,
    EvidenceVariableCategoryEntry, EvidenceVariableDefinitionModifierEntry,
    EvidenceVariableConstraintEntry, EvidenceVariableDataStorageEntry
};